module.exports = __webpack_public_path__ + "static/media/cat_mugs.a037399d.jpg";